<template>
  <div class="group-invitation-container" :class="{'offline': groupData && groupData.is_expired}">
    <template v-if="groupData && !groupData.is_expired">
      <img class="top-image" :src="groupData.top_image || 'https://files.wondercv.com/group-invite-v1-min.jpg'" alt="">

      <div class="group-logo-container" v-show="groupData.logo_url">
        <img :src="groupData.logo_url" alt="无该机构logo">
        <span class="iconfont iconx"></span>
        <img src="https://files.wondercv.com/translate-img/new_wondercv_logo_zh-CN.png" alt="">
      </div>

      <div class="submit-container">
        <div class="phone-number-wrapper" v-if="(!groupData.join_need_validate || (groupData.join_need_validate)) && !showTeamInfo">
          <div class="phone-number flex">
            <span class="number">86</span>
            <input v-model="phone" type="text" placeholder="输入手机号">
          </div>
          <div class="verify-code flex">
            <input type="text" v-model="verifyCode" placeholder="输入验证码">
            <span class="verify-btn" :class="{'sending-code': sending}" @click="sendVerifyCode">{{ verifyText }}</span>
          </div>
        </div>

        <input v-if="groupData.join_need_validate && !showTeamInfo" type="text" placeholder="请输入你的学号" v-model="studentNumber" class="student-number" @blur="checkStuNum(groupData.name)">

        <button v-if="!showTeamInfo" class="submit-btn" @click="savePhone">
          {{ groupData.button_text || '免费领取专属会员'}}
        </button>

        <button v-if="isWxMini || isWechatBrowser" class="submit-btn wechat-auth-btn" @click="scrollToTop">
          <i class="iconfont iconweixinfenxiang1" style="color: #4CBF00;font-size: 21px;"></i>
          微信登录领取
        </button>

      </div>

      <div v-if="showTeamInfo" class="team">
        <div class="invited-title">邀请两位校友注册<p> <span>你将</span> <img class="free-member" src="https://files.wondercv.com/RN/jigouhao.png"></p> </div>
        <div class="team_info">
          <div class="team_user">
            <img v-if="teamUserInfo[0].avatar" :src="teamUserInfo[0].avatar" alt="">
            <img v-else-if="teamUserInfo[0].avatar === null || teamUserInfo[0].avatar === 'null'" src="https://files.wondercv.com/RN/jigouhao/default.png" alt="">
            <span v-else>+</span>
            <p v-if="teamInfo.member_data && teamInfo.member_data[0].name">{{teamInfo.member_data[0].name}}</p>
            <p v-else-if="teamUserInfo[0] && (teamUserInfo[0].name === null || teamUserInfo[0].name === 'null')">超级简历用户</p>
            <p v-else>邀请好友</p>
          </div>
          <div class="team_user" >
            <img v-if="teamUserInfo[1].avatar" :src="teamUserInfo[1].avatar" alt="">
            <img v-else-if="teamUserInfo[1].avatar === null || teamUserInfo[1].avatar === 'null'" src="https://files.wondercv.com/RN/jigouhao/default.png" alt="">
            <span v-else :data-clipboard-text="content" @click="shareSchool"  class="submit-btn">+</span>
            <p v-if="teamUserInfo[1].name">{{teamUserInfo[1].name}}</p>
            <p v-else-if="teamUserInfo[1] && teamUserInfo[1].name === null || teamUserInfo[1].avatnamear === 'null'">超级简历用户</p>
            <p v-else>邀请好友</p>
          </div>
          <div class="team_user">
            <img v-if="teamUserInfo[2].avatar" :src="teamUserInfo[2].avatar" alt="">
            <img v-else-if="teamUserInfo[2].avatar === null || teamUserInfo[2].avatar === 'null'" src="https://files.wondercv.com/RN/jigouhao/default.png" alt="">
            <span v-else :data-clipboard-text="content" @click="shareSchool"  class="submit-btn">+</span>
            <p v-if="teamUserInfo[2].name">{{teamUserInfo[2].name}}</p>
            <p v-else-if="teamUserInfo[2] && teamUserInfo[2].name === null || teamUserInfo[2].avatnamear === 'null'">超级简历用户</p>
            <p v-else>邀请好友</p>
          </div>
        </div>
        <button v-if="!showVipVisibile" :data-clipboard-text="content" class="submit-btn" @click="shareSchool">分享给校友</button>
        <div class="vip-box" v-if="showVipVisibile">
          <img src="https://files.wondercv.com/RN/jigouhao/congratulation.png" alt="">
          <p>恭喜！获得30天超级简历会员</p>
        </div>
      </div>

      <div v-if="groupData.bottom_images && groupData.bottom_images.length" class="main-img">
        <img v-for="(item, index) in groupData.bottom_images" :key="index" :src="item" alt="">
      </div>

      <div v-else class="main-img">
        <img src="https://files.wondercv.com/group-invite-2-v1-min.jpg" alt="">
      </div>

      <div v-show="displayFooter" class="scroll-top" @click="scrollToTop">
        <button>{{ groupData.button_text || '立即免费领取' }}</button>
      </div>
    </template>
    <img v-else class="offline-image" src="https://logo.wondercv.com/banners/mDNGpg5clMHqQes.jpg" alt="">
  </div>
</template>

<script>
  import WNavBar from "@/components/global/w-navbar";
  import { envMixin, loginMixin, WxMixin } from '@/assets/js/mixin/global';
  import { componentsMixin } from '../../../assets/js/mixin/components'
  import Cookies from 'js-cookie';
  import { userMixin } from '@/assets/js/mixin/user';
  import {eventMixin} from "../../../assets/js/mixin/global";
  import {mapState} from "vuex";
  import {verifyRequired, updateJWT, startObserving} from "../../../assets/js/utils";
	import Clipboard from 'clipboard'
  export default {
    name: "group_invitation",
    mixins: [ envMixin, loginMixin, componentsMixin, eventMixin, WxMixin, userMixin ],
    components: {
      WNavBar
    },
    data () {
      return {
        // redirectUrl:'',
        sending: false,
        second: 60,
        phone: this.$route.query.phone || '',
        verifyCode: '',
        groupData: {
          group_member_count: 0,
          token: '',
          join_need_validate: false,
          name: '',
          logo_url: ''
        },
        validateCode: {
          "上海外国语大学": /(?![a-zA-Z]+$)[a-zA-Z0-9]{10,}/,
          "南京大学": /([0-9]{9}|[a-zA-Z]{2}[0-9]{7})$/,
          "清华大学": /2([0-9]+){9}$/,
          "南开大学": /(?![a-zA-Z]+$)[a-zA-Z0-9]{7,}/,
          "中山大学": /(?![a-zA-Z]+$)[a-zA-Z0-9]{8,}/
        },
        studentNumber:'', // 学号
        appId: process.env.VUE_APP_ENV === 'prod' ? '2098377241' : '2059326702',
        teamInfo:{},//队伍信息
        teamUserInfo:[
          {
            avatar:'',
            name:''
          },
          {
            avatar:'',
            name:''
          },
          {
            avatar:'',
            name:''
          }
        ],//队员信息
        content:'',//分享链接
        showVipVisibile:false,//是否显示已获得vip文案
        showTeamInfo:false,//是否显示组队信息
        isExist: false,    // 是否是新用户
        displayFooter: false,
      }
    },
    async mounted () {
      // captain_token是队伍token    groupToken是机构号token
      let { account, isCaption, captain_token} = this.$route.query
      let { groupToken } = this.$route.params
      this.content = process.env.VUE_APP_LINK + '/groups/' + groupToken + '/invite?account=' + account
      // 必须是队伍类型，才走此方法
      if(account){
        // 判断是否是队长
        if(!!isCaption){
          this.showTeamInfo = false
        }else{
          this.showTeamInfo = true
          // 创建队伍
          await this.createGroupTeam()
        }
      }

      try {
        await this.iosBridgeGet()
        this.groupData.token = groupToken
        // 获取当前机构的信息
        let res = await this.$api.user.getGroupMessage(this.groupData.token)
        if (res.code === 1000) {
          // console.log(res.data,"=====>groupData")
          this.groupData = res.data
        }else {
          this.showToast(res.message,1500)
        }
        // 是否带学号微信授权登录（初次进入页面不触发）
        const info = this.$db.ls.get('_group_login')
        if (info.type === 'login') {
          let payload = {
            type: '',
            group_token: this.groupData.token,
            client: '',
            captain_token:''
          }
          if(this.$route.query.captain_token){
            params.captain_token = this.$route.query.captain_token
          }
          let isWx = !!(this.isWxMini || this.isWechatBrowser)
          let params = this.initParams(payload, 'wechat_web')
          await this.groupLoginByWx(params, isWx, this.groupData.name, this.groupData.recieve_method)
        }
        await this.$route.meta.shareByWx(`HR 推荐的简历制作神器，${this.groupData.name}邀请你免费升级`, {
          title: `快来领取${this.groupData.name}专属的超级简历`,
          imgUrl: this.groupData.share_logo || this.groupData.logo_url || 'https://files.wondercv.com/App%20Icon@2x.png'
        })
      } catch (e) {
        console.error(e);
      }

      const element = document.querySelector('.submit-btn')

      startObserving(element, 0, (visible) => {
        this.displayFooter = !visible
      });
    },
    computed: {
      ...mapState('cv', ['cv', 'onlineCvBasic']),
      verifyText () {
        return this.sending ? `${ this.second } 秒后重发` : '获取验证码'
      },
      cvAccountToken () {
        let _t = Cookies.get('_t')
        let tokenPayload = JSON.parse(window.atob(_t.split('.')[1]))
        return tokenPayload.User.c_t
      },
      requiredField () {
        return [
          { val: this.phone, message: '请填写手机号' },
          { val: this.verifyCode, message: '请填写验证码' }
        ]
      },
      studentNumRequired() {
        return [
          { val: this.studentNumber, message: '请填写学号' }
        ]
      },
      disableState () {
        // 有学号校验并且是微信环境按钮验证学号
        if (this.groupData.join_need_validate && (this.isWxMini || this.isWechatBrowser)) {
          return verifyRequired(this.studentNumRequired)
        }else {
          return verifyRequired(this.requiredField)
        }
      }
    },
    methods: {
      //创建队伍
      async createGroupTeam(){
        let res = await this.$api.user.bingUser({
          cv_account_token:this.$route.query.account,
          group_token:this.$route.params.groupToken
        })
        if(res.code === 1000 || res.code === 20005){//如果当前用户已经在这个机构有队伍 并且是队长
          let teamRes = await this.$api.user.getGroupTeam({
            cv_account_token:this.$route.query.account,
            group_token:this.$route.params.groupToken
          })
          //处理成员信息
          if(teamRes.code === 1000){
            let { member_data, captain_data } = teamRes.data
            let index = member_data.map(target => target.identity).indexOf('captain')
            let ownerInfo = member_data[index]
            member_data.splice(index,1)
            member_data.unshift(ownerInfo)
            // 保存团队信息
            this.teamInfo = teamRes.data
            if(member_data.length >= 3){
              this.showVipVisibile = true
            }
            for(let i = 0;i<member_data.length;i++){
              this.teamUserInfo[i] = member_data[i]
            }
            // 更新当前分享的url
            this.content = process.env.VUE_APP_LINK + '/groups/' + this.$route.params.groupToken + '/invite?account=' + this.$route.query.account + '&captain_token=' + captain_data.captain_token + '&isCaption=true'
          }
        }else{
          this.showToast(res.message)
        }
      },
      //分享
      async shareSchool(){
        let ua = navigator.userAgent
        let wxMini = ua.includes('MicroMessenger') && ua.includes('miniProgram')   // 是否微信小程序
        if(wxMini){
          await this.$route.meta.shareByWx(`HR 推荐的简历制作神器，${this.groupData.name}邀请你免费升级`, {
            title: `快来领取${this.groupData.name}专属的超级简历`,
            imgUrl: this.groupData.share_logo || this.groupData.logo_url || 'https://files.wondercv.com/App%20Icon@2x.png'
          })
        }else{
          let clipboard = new Clipboard('.submit-btn')
          clipboard.on('success', e => {
            this.showToast('分享链接已复制，去发送给好友吧～')
            clipboard.destroy() // 释放内存
          })
        }
      },
      // 学号正则校验
      checkStuNum(name) {
        // 是否特殊学校的学号校验
        if (this.validateCode[name]) {
          let str = this.validateCode[name]
          if (!str.test(this.studentNumber)) {
            this.showToast('请输入正确的学号')
            return false
          }else {
            return true
          }
        }else {
          if (!/^(?![a-zA-Z]+$)[0-9A-Za-z]{6,19}$/.test(this.studentNumber)) {
            this.showToast('请输入正确的学号')
            return false
          }else {
            return true
          }
        }
      },
      // 格式化数字
      initNum(num) {
        if (num >= 1000) {
          return (num / 1000).toString().replace(/\./g,',')
        }else {
          return num
        }
      },
      scrollToTop() {
        if (this.isWxMini || this.isWechatBrowser) {
          const state = 'login';
          const redirectUrl = `${window.location.origin}${window.location.pathname}`;
          this.$db.ls.set('_group_login', { type: 'login' });
          this.weChatAuthorization('snsapi_userinfo', redirectUrl, state);
        } else {
          window.scrollTo({
            top: 0,
            // instant ：瞬间滚动    smooth ：平滑滚动
            behavior: "instant"
          })
        }
      },
      // 发送验证码
      async sendVerifyCode () {
        if (!this.sending) {
          if (!/^1[3456789]\d{9}$/.test(this.phone)) {
            this.showToast('请输入正确的手机号')
            return
          }
          if (this.groupData.token === '98029690') {
            let res = await this.$api.auth.checkUser({phone_number: this.phone})
            if (res.code === 1000) {
              // 不是新用户走登录逻辑
              this.isExist = !!res.data.exist;
            }
          }
          let captcha = new TencentCaptcha(this.appId, async (res) => {
            if (res.ret === 0) {

              let isSend = await this._sendCode(res.randstr,res.ticket,this.isExist)
              this.sending = true
              if (!isSend) {
                this.sending = false;
                return false;
              }
              let timer = setInterval(() => {
                this.second -= 1
                if (this.second === 0) {
                  clearInterval(timer)
                  this.sending = false
                  this.second = 60
                }
              }, 1000)

            }
          });
          captcha.show();
        }
      },
      async _sendCode (randstr, ticket, isCall) {
        let data = {}
        if(randstr && ticket){
          data = {captcha_rand_str: randstr, captcha_ticket: ticket}
        }
        let payload = {
          phone_number: this.phone,
          premise: 'without',
          new_code: true,
          ...data,
        }
        let res = await this.$api.auth.getValidateCodeV3(payload)
        if (res.code === 1000) {
          this.showToast('发送成功')
          return true;
        }
        // 是否是新用户验证 （脉脉机构号不是新用户的直接登录）
        else if (res.code === 2002) {
          this.showToast('非常抱歉，<br>本活动仅新用户可参与')
          return false;
        }else {
          this.showToast(res.message)
          return false;
        }
      },
      // 格式化参数
      initParams(params, type) {
        if (this.isWxMini) {
          params.client = 'miniprogram'
        }else if (this.isWechatBrowser) {
          params.client = 'wechat_browser'
        }else {
          params.client = 'mobile_browser'
        }
        if (this.groupData.join_need_validate) {
          params.student_id = this.studentNumber
        }
        // 暂时解决方案
        // params.phone_number = this.phone
        // params.phone_code = this.verifyCode
        params.type = type
        if (type === 'phone') {
          params.phone_number = this.phone
          params.phone_code = this.verifyCode
        }
        // 此功能本次暂时去掉，功能无问题
        // if (!this.groupData.join_need_validate || (this.groupData.join_need_validate && (!this.isWxMini && !this.isWechatBrowser))) {
        //   params.phone_number = this.phone
        //   params.phone_code = this.verifyCode
        //   params.type = 'phone'
        // }else {
        //   params.type = 'wechat_web'
        // }
        return params
      },
      // 点击登录领取机构号邀请福利
      async savePhone () {
        /***
         * 如果需要学号校验，再判断是否微信环境
         * 是微信环境：调取微信登录
         * 不是微信环境：调取手机号登录
         *
         * 如果不需要学号校验：任何环境都调取手机号登录
         * 页面 v-if 显示逻辑同上
         * ***/
        if (!this.groupData.join_need_validate || (this.groupData.join_need_validate && (!this.isWxMini && !this.isWechatBrowser))) {
          if (verifyRequired(this.requiredField)) {
            this.showToast(verifyRequired(this.requiredField), 2000)
            return
          }
        }
        if (this.groupData.join_need_validate && verifyRequired(this.studentNumRequired)) {
          this.showToast(verifyRequired(this.studentNumRequired),2000)
          return
        }else if (this.groupData.join_need_validate && !verifyRequired(this.studentNumRequired)){
          if (this.checkStuNum(this.groupData.name)) {
            this.$db.ls.set('_student_number',this.studentNumber)
          }else {
            return
          }
        }
        // captain_token是队伍token    groupToken是机构号token
        let payload = {
          type: '',
          group_token: this.groupData.token || null,
          client: '',
          captain_token:''
        }

        let data = {
          phone_number: this.phone,
          phone_code: this.verifyCode,
          source:'mobile_browser'
        }

        // 格式化参数
        let params = this.initParams(payload, 'phone')

        // console.log(this.$route,this.teamInfo,'params')
        // 已有队伍
        if (this.$route.query.captain_token) {
          params.captain_token = this.$route.query.captain_token
        } else if (this.teamInfo.captain_data && this.teamInfo.captain_data.captain_token){
          // 未有队伍，他就是队长
          params.captain_token = this.teamInfo.captain_data.captain_token
        }
        // console.log(params,'params')
        // phone_code: this.verifyCode

        // if ((this.isWxMini || this.isWechatBrowser) && this.groupData.join_need_validate) {
        //   let state = 'login'
        //   let redirectUrl = `${ process.env.VUE_APP_LINK }${ window.location.pathname }?${this.$route.query.account ? 'account='+this.$route.query.account : ''}${this.$route.query.captain_token ? '&caption_token='+this.$route.query.captain_token : ''}${this.$route.query.isCaption ? '&isCaption='+this.$route.query.isCaption : ''}`
        //   // this.redirectUrl = redirectUrl
        //   // return
        //   this.$db.ls.set('_group_login', { type: 'login' })
        //   this.weChatAuthorization('snsapi_userinfo', redirectUrl, state)
        // }else {
          // this.showToast('调用手机号登录');
          // return
          /***
           * 手机号登录时必定是新用户，老用户收取不到验证码
           * ***/
          let res = this.isExist ? await this.$api.auth.loginByPhone(data) : await this.$api.user.setGroupUserSignUp(params)
          if (res.code === 1000) {
            await updateJWT({
              jwt: res.data.jwt,
              jwt_timestamp: res.data.jwt_timestamp,
              cookieEndTime: 14 * 24 * 60 * 60
            })
            this.showToast(this.isExist ? '登录成功' : '领取成功');
            this.$db.ls.remove('_student_number')
            setTimeout(() => {
              if (this.groupData.recieve_method) {
                window.location.href = this.groupData.recieve_method
              }
            }, 1500);
          }
          else {
            this.showToast(res.message);
          }
        // }

      }
    }
  }
</script>

<style lang="scss">
  @media only screen and (min-width: 1024px) {
    body{
      width: 375px;
      margin: 0 auto!important;
    }
    html{
      font-size: 110px!important;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/cv/online-cv';

  .group-invitation-container{
    width: 375px;
    height: auto;
    @include ipx-content-bottom(80px);
    .top-image {
      width: 100%;
      object-fit: contain;
    }
    &.offline {
      height: 100vh;
      overflow: hidden;
      box-sizing: border-box;
      background-color: #fe634e;
    }
    .group-logo-container{
      width: 100%;
      height: 32px;
      display: flex;
      box-sizing: border-box;
      padding: 0 24px;
      margin-top: 10px;
      justify-content: space-around;
      align-items: center;
      img{
        max-width: 102px;
        max-height: 100%;
        /*object-fit: contain;*/
      }
      .iconfont{
        color: #404040;
        font-size: 20px;
      }
    }
    .submit-container{
      width: 100%;
      height: auto;
      margin-top: 24px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .student-number{
        outline: none;
        box-sizing: border-box;
        width: 300px;
        height: 44px;
        border: 1px solid #ebebeb;
        border-radius: 2px;
        margin-top: 17px;
        &::placeholder{
          color: #ebebeb;
        }
      }
      .submit-btn{
        width: 300px;
        height: 44px;
        background-color: #ff4f4c;
        color: #fff;
        line-height: 44px;
        margin-top: 23px;
        text-align: center;
        outline: none;
        border: none;
        border-radius: 2px;
        font-size: 16px;
      }

      .wechat-auth-btn {
        color: #404040;
        background-color: #fff;
        border: 1px solid #EBEBEB;
        margin-top: 8px;
      }

      .disable-button{
        background-color: #cfcfcf;
      }

      .phone-number-wrapper {
        width: 100%;
        padding: 0 38px;
        .phone-number, .verify-code {
          padding: 18px 0;
          border-bottom: 1px solid #EBEBEB;
          align-items: center;
          flex: 1;
        }
        .phone-number {
          align-items: center;
          margin-top: 14px;
          span {
            color: $color-title;
            &::after {
              content: '|';
              margin: 0 16px;
              color: #D8D8D8;
            }
            &::before {
              display: inline-block;
              content: '+';
              color: $color-title;
              margin-bottom: 2px;
            }
          }
        }
        .verify-btn {
          display: inline-block;
          width: 150px;
          text-align: right;
          white-space: nowrap;
          color: #4183FF;
          font-size: $font-size-medium-x;
        }
        .sending-code {
          color: rgba($color: #4183FF, $alpha: 0.6);
        }
        input {
          flex: 1;
          border: none;
          font-size: $font-size-medium-x;
          padding: 0;
          &::placeholder {
            color: #DBDBDB;
          }
        }
      }
      .online-footer {
        position: relative;
        margin-top: 8px;
      }

    }
    .team{
      width: 100%;
      text-align: center;
      color: #404040;
      line-height: 18px;
      font-size: 13px;
      margin-top: 30px;
      padding: 0 38px;
      box-sizing: border-box;
      .invited-title{
        &>p{
          margin-top: 8px;
          display: flex;
          justify-content: center;
          &>span{
            flex-shrink: 0;
          }
        }
      }
      .free-member{
        // height: 20px;
        width: 210px;
        display: inline-block;
        margin-left: 4px;
      }
      .team_info{
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        background: #F9F9F9;
        border-radius: 4px;
        padding: 16px 30px;
        box-sizing: border-box;
        margin-top: 16px;
        .team_user{
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: flex-start;
          p{
            width: 100%;
            text-align: center;
          }
          span{
            display: block;
            font-size: 13px;
            color: #CFCFCF;
            width: 45px;
            height: 45px;
            border: 1px dashed #CFCFCF;
            line-height: 40px;
            text-align: center;
            border-radius: 50%;
            margin: 0 auto;
            margin-bottom: 7px;
            display: block;
            margin-bottom: 7px;
          }
          img{
            display: block;
            width: 45px;
            height: 45px;
            margin: 0 auto;
            margin-bottom: 7px;
            border-radius: 50%;
          }
          .submit-btn{
            background: none;
          }
        }
      }
      .submit-btn{
        width: 300px;
        height: 44px;
        background-color: #ff4f4c;
        color: #fff;
        line-height: 44px;
        margin-top: 23px;
        text-align: center;
        outline: none;
        border: none;
        border-radius: 2px;
        font-size: 16px;
      }
      .vip-box{
        width: 300px;
        height: 44px;
        background: #FFF8EB;
        border-radius: 4px;
        color: #D59960;
        text-align: center;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        margin-top: 23px;
        img{
          display: block;
          width: 23px;
          height: 23px;
          margin-right: 4px;
        }
      }
    }
    .main-img{
      width: 100%;
      margin-top: 24px;
      img{
        width: 100%;
        object-fit: contain;
        display: block;
      }
    }
    .scroll-top {
      position: fixed;
      bottom: 0;
      width: 100vw;
      box-sizing: border-box;
      padding: 12px 16px;
      background-color: #fff;
      box-shadow: 0 -6px 8px 0 rgba($color: #000000, $alpha: 0.06);
      @include ipx-content-bottom(12px);
      button {
        width: 100%;
        height: 44px;
        border-radius: 2px;
        color: #fff;
        background-color: #FF4F4C;
        text-align: center;
        line-height: 44px;
        outline: none;
        border: none;
        font-size: 16px;
      }
    }

    .offline-image {
      width: 100%;
      object-fit: contain;
    }
  }
</style>
